export const isNewLayoutEnabled = false;

export const KYC_STATUS_LABELS = {
    APPROVED: 'approved',
    MANUAL_REVIEW: 'manual_review',
    DECLINED: 'declined',
    SUBMITTED: 'submitted',
    RESUBMITTED: 'resubmitted',
    RESET: 'reset'
}

export const COMPANY_STATUS_LABELS = {
    PENDING: 'pending',
    PRE_APPROVED: 'pre_approved',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    BLOCKED: 'blocked',
    WAITING_DOCUMENTS: 'waiting_documents',
    GATEWAY_PENDING: 'gateway_pending',
    WAITING_URL: 'waiting_url',
    RESUBMISSION_REQUESTED: 'resubmission_requested',
}

// Espelho de `User.PRE_REGISTRATION_DONE_STATUSES` do backend, que é o que a afiliação cobra:
// a conta presa a um CPF checado na Receita. `pending` é a conta que ainda não fez o
// pré-cadastro; `waiting_url`, `rejected` e `blocked` não são etapa a caminho da aprovação.
// Não é a régua de layout do Financeiro (`FINANCIAL_PREREGISTRATION_DONE_STATUSES`).
export const PRE_REGISTRATION_DONE_STATUSES = [
  COMPANY_STATUS_LABELS.PRE_APPROVED,
  COMPANY_STATUS_LABELS.WAITING_DOCUMENTS,
  COMPANY_STATUS_LABELS.GATEWAY_PENDING,
  COMPANY_STATUS_LABELS.RESUBMISSION_REQUESTED,
  COMPANY_STATUS_LABELS.APPROVED,
];

export const hasCompletedPreRegistration = (companyStatus) =>
  PRE_REGISTRATION_DONE_STATUSES.includes(companyStatus);

// Status sem caminho de volta ao pré-cadastro: o Financeiro não remonta o wizard pra eles
// (`rejected` e `blocked` têm tela própria; `waiting_url` não tem mapeamento). Um "complete seu
// cadastro" aqui seria um pedido sem saída.
export const PRE_REGISTRATION_UNAVAILABLE_STATUSES = [
  COMPANY_STATUS_LABELS.REJECTED,
  COMPANY_STATUS_LABELS.BLOCKED,
  COMPANY_STATUS_LABELS.WAITING_URL,
];

export const isPreRegistrationUnavailable = (companyStatus) =>
  PRE_REGISTRATION_UNAVAILABLE_STATUSES.includes(companyStatus);

export const SOCIAL_NAME_FIELD_LABEL = 'Nome Social (opcional)';
export const SOCIAL_NAME_HELPER_TOOLTIP =
  'Nome pelo qual você deseja ser identificado, quando diferente do seu nome civil.';
